import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { DEFAULT_APP_LABEL } from '@comsbi/common/src/constants/appRetail';
import { AppLabel } from '@comsbi/common/src/types/models';

Vue.use(VueI18n);

// appから注入
const custom: AppLabel = JSON.parse(window.LABEL || '{}');

/**
 * NOTE: 開発時表示確認用
 * 全てのデフォルトラベルを `[]` で囲う
 */
// const custom = Object.fromEntries(
//   Object.entries(DEFAULT_APP_LABEL).map(([key, values]) => [
//     key,
//     Object.fromEntries(Object.entries(values).map(([k, v]) => [k, `[${v}]`])),
//   ])
// );

const messages = {
  default: DEFAULT_APP_LABEL,
  custom,
};

const i18n = new VueI18n({
  locale: 'custom',
  fallbackLocale: 'default',
  messages,
});

export { i18n };
